import * as url from "../url_helper";

import { post } from "../api_helper";

export const addRole = data => post(url.ADD_ROLE, data);

export const getRole = data => post(url.GET_ROLE, data);

export const getOneRole = data => post(url.GET_ONE_ROLE, data);

export const editRole = data => post(url.EDIT_ROLE, data);

export const getRolePermission = data => post(url.GET_ROLEPERMISSION, data)

export const editRolePermission = data => post(url.EDIT_ROLEPERMISSION, data);

export const deleteRole = data => post(url.DELETE_ROLE, data);



